<template>
  <div class="tableContent" ref="tableContent" id="manageLog"> 
    <el-form  :model="searchForm" class="searchFrom" ref="searchForm" >
      <el-input v-model="searchForm.user_name.value" placeholder="用户名"  @keyup.enter.native="searchList"> </el-input>
      <el-select v-model="searchForm.menu_name.value" filterable clearable placeholder="菜单名称" @focus="getPidList">
        <el-option :value="item.name" v-for="item in pidList" :key="item.id" :label="item.name" > 
        </el-option> 
      </el-select>
      <div class="createTime">
         <el-input v-model="timeDay" placeholder="请选择操作时间"></el-input>
         <el-date-picker @change="timeRange"   v-model="timeRangePicker"
          type="datetimerange" range-separator="至"  :default-time="['00:00:00' , '23:59:59']" 
         start-placeholder="开始日期"  value-format="yyyy-MM-dd HH:mm:ss" end-placeholder="结束日期" placeholder="选择操作时间"></el-date-picker>
      </div>
      <el-select v-model="searchForm.action_title.value" filterable clearable placeholder="操作" @focus="getOptsListLog">
        <el-option :value="item.value" v-for="item in optsList" :key="item.id" :label="item.value" > 
        </el-option> 
      </el-select>
      
      <div class="formBtnContainer" >
        <span class="btn btn-add" @click="searchListClick" >
          <svg class="icon" aria-hidden="true" >
            <use xlink:href="#icon_search"></use>
          </svg>
          <span>查询</span>
        </span>
        <span class="btn"  @click="resetFrom()">
          <svg class="icon" aria-hidden="true" >
            <use xlink:href="#icon_rest"></use>
          </svg>
          <span>重置</span>
        </span>
      </div>
    </el-form>
    <div class="tableContainer" v-if="$_has('/admin_log/list')">
      <el-table :data="tableList" v-loading="loading" border  :height="tableHeight" header-row-class-name="tableHeader"  row-class-name="tableRow"  @selection-change="handleSelectionChange">
        <el-table-column prop="user_name"  label="用户名"></el-table-column>
        <el-table-column prop="menu_name"  label="菜单名称" > </el-table-column>
        <el-table-column prop="create_time"  label="操作时间" ></el-table-column>
        <el-table-column prop="action_title"  label="操作" ></el-table-column>
        <el-table-column  label="详情" class-name='optionsCol'>
          <template slot-scope="scope">
            <span @click.stop="detailClick(scope.row)" class="textBtnEdit" v-if="$_has('/admin_log/desc')">详情</span>
          </template>
        </el-table-column>
        <div slot="empty">
					<p>
						<img src="@/assets/img/noData.png"/>
					</p>
					<p style="color:#030303;"><span>暂无相关数据</span></p>
				</div>
      </el-table>
    </div>
    <div style="position:relative;height:8vh;padding-top:20px;min-height:70px"  ref="pagination">
      <div class="pagination">
        <el-pagination  background @current-change="curPageChange" @size-change="sizeChange"
        :current-page="current_page" :page-sizes="page_sizes" :page-size="page_size" 
        :layout="total >= 6 ? 'prev, pager, next, total, sizes,  jumper':'pager, next, total, sizes,  jumper'"
        :total="total">
        </el-pagination>
      </div>
    </div>
   
    <LogDetail ref="logDetail" v-show="showLogDetail"  v-on:isShowLogDetail='isShowLogDetail'></LogDetail>

  </div>
</template>
<script>
import { LogDetail }  from './components'
import { list, listDetail } from '@/api/log'
import { setSearchParams } from '@/utils/index'
import { tree, getOptsList} from '@/api/menu'
export default {
  data(){
    return{
      searchForm:{
        user_name:{value:''},
        action_title:{value:''},
        create_time:{value:'',op:'RANGE'},
        menu_name:{value:''}
      },
      total: 5,
      current_page: 1,
      page_sizes:[10, 25, 50, 100],
      page_size:25,
      tableHeight: null,
      tableList:[],
      delList:[],
      timeRangePicker:'',
      timeDay:'',
      pidList:[],
      optsList:[],
      showLogDetail:false,
      loading:false
    }
  },
  mounted(){
    let that = this;
    // 注：window.onresize只能在项目内触发1次
    window.onresize = function windowResize () {
        // 通过捕获系统的onresize事件触发我们需要执行的事件
      that.setTableHeight()
    }
    
  },
  watch:{
    timeRangePicker:function(n,o){
      if(n==null){
        this.timeDay = ""
      }
    }
  },
  components:{LogDetail},
  created(){
    this.searchList();
  },
  methods:{
    searchListClick(){
      this.current_page = 1;
      this.searchList()
    },
    isShowLogDetail(){
      this.showLogDetail = !this.showLogDetail
    },
    getOptsListLog(){
      getOptsList().then(res=>{
        let arr =  []
        for(let i in res) {
          let obj = {}
          obj.value = res[i]
          arr.push(obj)
        }
        this.optsList = arr
      })
    },
    getPidList(){
      tree().then(res=>{
        let arr = []
        this.pidList = arr.concat(res.rows) 
        this.menuList = this.pidList
      })
    },
    searchList(){
      this.loading = true
      let params =  setSearchParams(this.searchForm,this.page_size,this.current_page)
      list(params).then(res=>{
        this.total = res.total
        this.tableList = res.data
        this.loading = false
        this.setTableHeight()
      })
    },
     resetFrom(){
      let menuManage = this.searchForm
      for(let item in menuManage){
        menuManage[item].value =''
      }
      this.timeDay =""
      this.searchList();
    },
    detailClick(row){
      this.$refs.logDetail.detail = row
      this.isShowLogDetail()
    },
    handleSelectionChange(list){
      let arr = new Array()
      for (let item in list){
        arr.push(list[item].id)
      }
      this.delList = arr
    },
    timeRange(arr){
      if(arr){
        let str = arr[0] + ' - ' + arr[1]
        this.timeDay = arr[0].split(' ')[0] +'-'+arr[1].split(' ')[0]
        this.searchForm.create_time.value = str
      }else{
        this.searchForm.create_time.value = null
      }
      
    },
    tableRow({row}){
      if(!row.statusBoolean){
        return 'statusStop tableRow'
      }else{
        return 'tableRow'
      }

    },
    setTableHeight(){
      let searchFormHeight = this.$refs.searchForm.$el.offsetHeight;
      let manageMenuHeight = this.$refs.tableContent.offsetHeight +20;
      let paginationHeight  = 0
      if(this.$refs.pagination){
         paginationHeight = this.$refs.pagination.offsetHeight + 30
      }
      let btnContainerHeight = 0
       if(this.$refs.btnContainer){
        btnContainerHeight = this.$refs.btnContainer.offsetHeight 
      }
      this.tableHeight = manageMenuHeight - searchFormHeight - paginationHeight -btnContainerHeight  +'px'
    },
    curPageChange(value){
      this.current_page = value;
      this.searchList()
    },
    sizeChange(value){
      this.page_size = value;
      this.searchList()
    }
  }

}
</script>

<style lang="scss">
@import '@/assets/scss/common.scss';

#manageLog{
  .searchFrom{
    // margin-bottom: 10px;
    margin-bottom: 1.1vh;
  }
  .createTime{
    position: relative;
    display: inline-block;
    width: 16.5%;
    height: 36px;
    line-height: 36px;
    padding-right: 3%;
    margin-bottom: 24px;
    @include respond('1310'){width: 20%;padding-right: 3.2%;}
    >.el-input{
      height: 36px;
      line-height: 36px;
      >.el-input__inner{
        height: 36px;
        line-height: 36px;
      }
    }
    .el-date-editor.el-range-editor.el-input__inner.el-date-editor--datetimerange{
      position: absolute;
      left: 0px;
      top: 3px;
      opacity: 0;
      height: 100%;
      width: 100%;
    }
  }
  .formBtnContainer{
    position: absolute;
    right: 27px;
    // top: 34px;
    top: 3.6vh;
  }
}
 
</style>